<template>
  <section
    v-if="visible"
    class="component-d741a204"
    resmed-component-name="documents_icon-line_3col_text_link_cta"
    v-on:click.capture="active = ''"
    v-bind:style="{ 'background-color': acf.layout['background-color'] }"
    v-bind:id="[
      `${encodeURI(
        acf.headline
          .toLowerCase()
          .trim()
          .replaceAll(' ', '-')
      ).replaceAll('%', '')}`,
    ]"
  >
    <div class="row" v-if="acf.filter_option !== '' && $route.params.category">
      <div class="container">
        <div class="col text-center">
          <select class="filterSelect" @change="sortItems($event)">
            <template v-for="(item, i) in acf.filter_option">
              <option
                :key="i"
                :value="item.value"
                :id="item.value === 'null' ? 'true' : 'false'"
                :selected="item.value === 'null' ? 'selected' : null"
                :disabled="item.value === 'null' ? 'true' : null"
                >{{ item.label }}</option
              >
            </template>
          </select>
          <input class="sortinput" type="text" />
          <button class="sortbtn" @click="sortEdited()">val</button>
        </div>
      </div>
    </div>
    <div
      class="component"
      v-bind:class="[`text-color-${historicalData.layout['text-color']}`]"
    >
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h5
              style="font-size: 1.3rem; font-weight: 400; line-height: 1.4;"
              v-if="historicalData.name"
              v-html="historicalData.name"
            ></h5>
            <h2
              style="font-size: 2.5rem; font-weight: 400; line-height: 1.4;"
              v-if="historicalData.headline"
              v-html="historicalData.headline"
              v-bind:class="{ '-has-eyebrow': !historicalData.name }"
            ></h2>
            <p
              class="disclaimer-text pt-md-4 mx-auto"
              v-if="historicalData.disclaimer !== ''"
            >
              {{ historicalData.disclaimer }}
            </p>
            <div class="items row justify-content-start">
              <div
                class="col-md-3 p-0"
                v-for="(item, i) in historicalData.items"
                :key="i"
              >
                <div class="d-flex flex-column my-3 boxShadow">
                  <a
                    v-on:click.stop="active = item.post_title"
                    class="btn cta-plain text-red icon text-wrap col-12 p-0"
                    style="line-height: 1.4;"
                    v-bind:class="{
                      'text-white':
                        historicalData.layout['text-color'] === 'white',
                    }"
                  >
                    <div class="boxShadowContainer">
                      <!-- files which are not locked -->
                      <div
                        v-if="item && item.locked == 'false'"
                        class="d-inline w-100"
                      >
                        <!-- single language documents -->
                        <a
                          v-if="item && item.files"
                          :href="
                            item.files && item.files.selectedFile != undefined
                              ? getDocumentHref(
                                  item.files.selectedFile,
                                  item.locked
                                )
                              : getDocumentHref(item.files[0].file, item.locked)
                          "
                          target="_blank"
                          @click="dataLayer(item, item.acf.files[0])"
                        >
                          <div class="col-12 p-0">
                            <div class="internal_only_document">
                              <span
                                v-if="
                                  item.availability == 'true' ||
                                    item.availability.includes('true')
                                "
                                >Internal ONLY</span
                              >
                            </div>
                            <div
                              class="document_title"
                              v-b-tooltip.hover
                              :title="item.post_title"
                            >
                              <strong>
                                {{ item.post_title }}
                                <span
                                  v-tooltip="{
                                    content: item.manual_tooltip,
                                    classes: ['tooltipQualityAssistant'],
                                  }"
                                >
                                  <svg
                                    v-if="item.manual_tooltip"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    class="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                    />
                                    <path
                                      d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                                    />
                                  </svg>
                                </span>
                              </strong>
                            </div>

                            <div
                              class="d-flex justify-content-between align-items-center mt-2 col-12 p-0"
                              style="width: inherit;"
                            >
                              <div
                                class="d-flex flex-column justify-content-center align-items-start p-0 col-12"
                              >
                                <span class="mb-1 document_data">
                                  ID
                                  {{
                                    item.files &&
                                    item.files.selectedFile != undefined
                                      ? getDocumentId(
                                          item.files.selectedFile,
                                          item.locked
                                        )
                                      : getDocumentId(
                                          item &&
                                            item.files.selectedFile &&
                                            item.files[0] &&
                                            item.files.find(
                                              (file) =>
                                                file.file ===
                                                item.files.selectedFile
                                            ).file,
                                          item.locked
                                        ) || "--"
                                  }}
                                </span>
                                <div
                                  class="d-flex justify-content-between align-items-center"
                                >
                                  <span class="document_data">
                                    {{
                                      getDocumentDate(
                                        item.files,
                                        item.files.selectedFile
                                      ) || "--"
                                    }}
                                  </span>
                                  <div
                                    style="border-right: 1px solid #a9a9a9; border-right: 1px solid #a9a9a9; width: 10px; height: 16px;"
                                  ></div>
                                  <span class="document_data">{{
                                    getSize(
                                      item.files.find(
                                        (file) =>
                                          file.file === item.files.selectedFile
                                      )
                                    ) || "--"
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>

                      <!-- files which are locked -->
                      <div style="text-align: left;" v-else>
                        <a
                          v-if="
                            item &&
                              item.locked != 'false' &&
                              item.files.length === 0
                          "
                          :href="
                            item.files &&
                              item.files.selectedFile != undefined &&
                              getDocumentHref(
                                item.files.selectedFile,
                                item.locked
                              )
                          "
                          v-bind:target="
                            getDocumentTarget(item.files, item.locked)
                          "
                          @click.prevent="
                            saveMyDownload(
                              getDocumentHref(item.files, item.locked)
                            )
                          "
                          style="width: 100%; color: #0D0A15;"
                          :style="[
                            getDocumentTarget(item.files, item.locked) === ''
                              ? { cursor: 'not-allowed' }
                              : { cursor: 'pointer' },
                          ]"
                        >
                          <div
                            v-if="item && item.locked != 'false'"
                            style="color: #020202"
                          >
                            <div class="internal_only_document">
                              <span
                                v-if="
                                  item.availability == 'true' ||
                                    item.availability.includes('true')
                                "
                                >Internal ONLY</span
                              >
                            </div>
                            <div
                              class="document_title"
                              v-b-tooltip.hover
                              :title="item.post_title"
                            >
                              <strong>
                                {{ item.post_title }}
                                <span
                                  v-tooltip="{
                                    content: item.manual_tooltip,
                                    classes: ['tooltipQualityAssistant'],
                                  }"
                                >
                                  <svg
                                    v-if="item.manual_tooltip"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    class="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                    />
                                    <path
                                      d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                                    />
                                  </svg>
                                </span>
                              </strong>
                            </div>
                            <!-- locked file -->
                          </div>
                          <img
                            v-bind:src="getImagePath(item.locked)"
                            class="d-inline-block align-middle my-2"
                          />
                          {{
                            item.post_title
                              .split(" ")
                              .join("_")
                              .toLowerCase() ===
                            "resscan_essentials__klinisk_guide"
                              ? "Se klinisk guide här:"
                              : item.post_title
                                  .split(" ")
                                  .join("_")
                                  .toLowerCase() ===
                                "resscan_essential_ver._1.0_installation"
                              ? "Ladda ner mjukvaran här:"
                              : item.post_title
                                  .split(" ")
                                  .join("_")
                                  .toLowerCase() === "resscan_ver_7.1"
                              ? "Ladda ner mjukvaran här:"
                              : item.post_title
                                  .split(" ")
                                  .join("_")
                                  .toLowerCase() === "resscan_klinisk_guide"
                              ? "Se klinisk guide här:"
                              : getDocumentCta(item.cta, item.locked)
                          }}
                        </a>

                        <a
                          v-else
                          :href="
                            item.files &&
                              item.files.selectedFile != undefined &&
                              getDocumentHref(
                                item.files.selectedFile,
                                item.locked
                              )
                          "
                          v-bind:target="
                            item.files.length === 1
                              ? getDocumentTarget(
                                  item.files[0].file,
                                  item.locked
                                )
                              : getDocumentTarget(
                                  item.files.selectedFile,
                                  item.locked
                                )
                          "
                          @click.prevent="
                            item.files.length === 1
                              ? saveMyDownload(item.files[0].file)
                              : saveMyDownload(item.files.selectedFile)
                          "
                          :style="[
                            getDocumentTarget(
                              item.files[0].file,
                              item.locked
                            ) === ''
                              ? { cursor: 'not-allowed' }
                              : { cursor: 'pointer' },
                          ]"
                        >
                          <div
                            v-if="item && item.locked != 'false'"
                            style="color: #020202"
                          >
                            <p
                              v-if="
                                errorMessage &&
                                  errorMessage.url === item.files[0].file
                              "
                              style="color: red;"
                            >
                              {{ errorMessage.error }}
                            </p>
                            <div
                              class="internal_only_document"
                              v-if="
                                item.availability == 'true' ||
                                  item.availability.includes('true')
                              "
                            >
                              <span
                                v-if="
                                  item.availability == 'true' ||
                                    item.availability.includes('true')
                                "
                                >Internal ONLY</span
                              >
                            </div>
                            <div
                              class="document_title"
                              v-b-tooltip.hover
                              :title="item.post_title"
                            >
                              <strong>
                                {{ item.post_title }}
                                <span
                                  v-tooltip="{
                                    content: item.manual_tooltip,
                                    classes: ['tooltipQualityAssistant'],
                                  }"
                                >
                                  <svg
                                    v-if="item.manual_tooltip"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    class="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                                    />
                                    <path
                                      d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                                    />
                                  </svg>
                                </span>
                              </strong>
                            </div>
                            <!-- locked file -->
                          </div>
                          <div
                            class="d-flex justify-content-center col-12 mt-2 p-0"
                          >
                            <div
                              v-if="
                                item && item.cta.includes('Download Software')
                              "
                              class="d-flex flex-column mt-2 col-12"
                            >
                              <div
                                class="d-flex align-items-center"
                                style="gap: 10px"
                              >
                                <span
                                  style="font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 700;"
                                  >{{
                                    getDocumentCta(
                                      item && item.cta,
                                      item.locked
                                    )
                                  }}</span
                                >
                              </div>
                              <div
                                class="d-flex align-items-center"
                                style="font-size: 12px; font-weight: 400; color: #a9a9a9; font-family: 'Plus Jakarta Sans', sans-serif;"
                              >
                                {{
                                  getDocumentDate(
                                    item.files,
                                    item.files.selectedFile
                                  ) || "--"
                                }}
                                &nbsp;|&nbsp;
                                <span>{{
                                  getSize(
                                    item.files.find(
                                      (file) =>
                                        file.file === item.files.selectedFile
                                    )
                                  ) || "--"
                                }}</span>
                              </div>
                            </div>
                            <div
                              v-else
                              class="d-flex flex-column justify-content-center align-items-start px-1 mx-2 col-12"
                            >
                              <span
                                class="mb-1"
                                style="
                                  font-size: 12px;
                                  font-weight: 400;
                                  font-family: 'Plus Jakarta Sans', sans-serif;
                                  color: rgb(169, 169, 169);"
                              >
                                <span style="font-weight: 400; font-size: 12px;"
                                  >ID
                                </span>
                                {{
                                  getDocumentId(
                                    item.files.selectedFile,
                                    item.locked
                                  )
                                }}
                              </span>
                              <div
                                class="d-flex justify-content-between align-items-center"
                                style="width:max-content"
                              >
                                <span
                                  style="
                                  font-size: 12px;
                                  font-weight: 400;
                                  color: #a9a9a9;
                                  font-family: 'Plus Jakarta Sans', sans-serif;
                                "
                                  >{{
                                    getDocumentDate(
                                      item.files,
                                      item.files.selectedFile
                                    ) || "--"
                                  }}</span
                                >
                                <div
                                  style="border-right: 1px solid #a9a9a9; border-right: 1px solid #a9a9a9; width: 10px; height: 16px;"
                                ></div>
                                <span
                                  style="
                                  font-size: 12px;
                                  font-weight: 400;
                                  color: #a9a9a9;
                                  font-family: 'Plus Jakarta Sans', sans-serif;
                                "
                                  >{{
                                    getSize(
                                      item.files.find(
                                        (file) =>
                                          file.file === item.files.selectedFile
                                      )
                                    ) || "--"
                                  }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </a>

                  <div
                    class="select-overlay-container d-flex justify-content-start align-center m-0"
                    style="gap: 6px;"
                    v-if="item.historical && item.files.length > 0"
                  >
                    <select
                      v-model="item.files.selectedVersion"
                      @change="
                        updateFiles(item.files, item.files.selectedVersion)
                      "
                    >
                      <option
                        v-for="file in item.files"
                        :key="file.version"
                        :value="file.version"
                      >
                        Ver. {{ file.version }}
                      </option>
                    </select>

                    <select v-model="item.files.selectedFile">
                      <option
                        v-for="file in getFilteredFiles(
                          item.files,
                          item.files.selectedVersion
                        ) &&
                          getFilteredFiles(
                            item.files,
                            item.files.selectedVersion
                          ).files"
                        :key="file.file"
                        :value="file.file"
                      >
                        {{ file.language }}
                      </option>
                    </select>
                    <a
                      :href="
                        item.files && item.files.selectedFile != undefined
                          ? getDocumentHref(item.files.selectedFile, 'false')
                          : getDocumentHref(item.files[0].file, 'false')
                      "
                      target="_blank"
                      class="btn cta-plain text-wrap col-12 p-0"
                      id="img-1"
                    >
                      <img
                        style="height: 26px;"
                        src="@/assets/images/download_icon_black.png"
                        alt=""
                      />
                    </a>
                  </div>

                  <div
                    class="d-flex justify-content-start"
                    style="gap: 6px;"
                    v-else
                  >
                    <div
                      class="select-overlay-container m-0"
                      v-if="item && item.files && item.files.length >= 1"
                      :style="{
                        cursor:
                          item.files.length === 1 ? 'not-allowed' : 'pointer',
                      }"
                    >
                      <!-- {{ item.files.selectedFile }} -->
                      <!-- <div v-for="singleitem in item.files">
                        {{ singleitem.file === item.files.selectedFile }}
                      </div> -->
                      <select
                        v-model="item.files.selectedFile"
                        :class="{
                          'disable-pointer-events': item.files.length === 1,
                        }"
                        v-if="item && item.files"
                      >
                        <option
                          v-for="singleitem in item.files"
                          :value="singleitem.file"
                          :key="singleitem.file"
                        >
                          {{ singleitem.language }}
                        </option>
                      </select>
                      <div
                        class="select-overlay"
                        v-if="item.files.length === 1"
                      ></div>
                    </div>
                    <a
                      v-if="
                        item &&
                          item.files &&
                          (item.locked == 'false' ||
                            item.locked == 'true' ||
                            item.locked == 'APPROVED')
                      "
                      :href="
                        item.files.length === 1
                          ? getDocumentHref(item.files[0].file, item.locked)
                          : getDocumentHref(
                              item.files.selectedFile != undefined
                                ? item.files.selectedFile
                                : item.files[0].file,
                              item.locked
                            )
                      "
                      target="_blank"
                      @click="dataLayer(item, item.files[0])"
                      @click.prevent="
                        saveMyDownload(
                          item.files.length === 1
                            ? getDocumentHref(item.files[0].file, item.locked)
                            : getDocumentHref(
                                item.files.selectedFile != undefined
                                  ? item.files.selectedFile
                                  : item.files[0].file,
                                item.locked
                              )
                        )
                      "
                      id="img-2"
                    >
                      <img
                        style="height: 26px;"
                        src="@/assets/images/download_icon_black.png"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="resource-center mt-5" v-if="historicalData.cta.href">
              <a
                v-bind:href="historicalData.cta.href"
                v-bind:target="historicalData.cta.target"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ historicalData.cta.text }}</a
              >
            </div>

            <p class="text-center font-weight-bold pt-4" v-if="invalidAccess">
              <em>{{
                $getTranslation(
                  "You don't have access permissions to view the PDF's for this region/category/products",
                  $route.params.region
                )
              }}</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import inView from "in-view"; // https://github.com/camwiegert/in-view
import documenLink from "./document-link";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "component-d741a204", // documents_icon-line_3col_text_link_cta
  components: {
    documenLink,
  },
  props: ["acf", "images"],
  data() {
    return {
      active: "",
      isloggedIn: false,
      invalidAccess: false,
      items: [],
      historicalData: [],
      errorMessage: "",
    };
  },
  computed: {
    ...mapState(["userId, country"]),
    visible() {
      let role = $cookies.get("role");
      const categoryCookie = $cookies.get("categories");

      try {
        if (
          (categoryCookie == "" || categoryCookie == null) &&
          (role != "" || role != null)
        ) {
          this.$cookies.set(
            "categories",
            role && role.replace(/approved/g, "approve"),
            null,
            "/",
            window.location.hostname.includes(".resmed.com")
              ? ".resmed.com"
              : "localhost"
          );
        }
      } catch (error) {
        console.log(error);
      }

      // Check accessible_roles first
      if (!this.acf.accessible_roles || !this.acf.accessible_roles.length) {
        return true;
      }
      if (!role) {
        return false;
      }
      if (!role.includes(`${this.acf.accessible_roles[0]}_approved`)) {
        return false;
      }

      // Additional URL-based category check
      const roles = (role && role.split(",").map((r) => r.trim())) || [];
      const hasAnyTechnicalRole = roles.some(
        (r) =>
          r.includes("sleep_approved") ||
          r.includes("ventilator_approved") ||
          r.includes("oxygen_approved")
      );

      const url = window && window.location.href;

      // Check specific category URLs
      if (url.includes("sleep") && roles.includes("sleep_approved")) {
        return true;
      } else if (
        url.includes("ventilator") &&
        roles.includes("ventilator_approved")
      ) {
        return true;
      } else if (url.includes("oxygen") && roles.includes("oxygen_approved")) {
        return true;
      } else if (
        hasAnyTechnicalRole &&
        !url.includes("sleep") &&
        !url.includes("ventilator") &&
        !url.includes("oxygen")
      ) {
        // Allow access to general pages (non-category specific)
        return true;
      }

      return false;
    },
    isResmedUser() {
      const email = $cookies.get("rocEmail");
      // console.log("287",email)
      if (email && email.toLowerCase().includes("@resmed.")) {
        return true;
      }
      return false;
    },
  },

  methods: {
    _active() {
      setTimeout(() => {
        this.active = "";
      }, 100);
    },

    getLanguageByRegion() {
      const languageByCountry = {
        "en-us": "English",
        "en-au": "English",
        "en-ap": "English",
        "en-gb": "English",
        "en-in": "English",
        "pt-br": "Portuguese",
        "es-xl": "Spanish",
        "zh-cn": "Chinese",
        "ja-jp": "Japanese",
        "sv-se": "Swedish",
        "nb-no": "Norsk",
        "fi-fi": "Suomi",
      };

      return languageByCountry[this.$route.params.region];
    },

    async convertToFormattedData(originalData) {
      const groupedData = {};

      for (const post of originalData.items) {
        const postKey = post.post_title;
        const acf = post.acf != null ? post.acf : {};

        if (post.acf != null) {
          if (!groupedData[postKey]) {
            groupedData[postKey] = {
              post_title: postKey,
              files: [],
              historical: acf.historical || false,
              cta: acf.cta || "",
              availability: acf.availability || "",
              locked: acf.locked || false,
              manual_tooltip: acf.manual_tooltip || "",
              errorMessage: null,
            };
          }

          const files = acf.files || [];
          for (const file of files) {
            const version = file.version;

            if (acf.historical) {
              if (!groupedData[postKey].files[version]) {
                groupedData[postKey].files[version] = {
                  version: version,
                  files: [],
                  cta: acf.cta || "",
                  availability: acf.availability || "true",
                  locked: acf.locked || "true",
                  manual_tooltip: acf.manual_tooltip || "",
                };
              }

              groupedData[postKey].files[version].files.push({
                language: file.language,
                file: file.file,
                type: file.type,
                size: file.size,
                date: file.date,
                availability: acf.availability || "true",
                locked: acf.locked || "true",
                cta: acf.cta || "",
                manual_tooltip: acf.manual_tooltip || "",
              });
            } else {
              groupedData[postKey].files.push({
                language: file.language,
                file: file.file,
                type: file.type,
                size: file.size,
                date: file.date,
                availability: acf.availability || "true",
                locked: acf.locked || "true",
                cta: acf.cta || "",
                manual_tooltip: acf.manual_tooltip || "",
              });
            }
          }
        }
      }

      const data = Object.values(groupedData).map((group) => ({
        post_title: group.post_title,
        files: Object.values(group.files),
        historical: group.historical || false,
        cta: group.cta,
        availability: group.availability,
        locked: group.locked,
        manual_tooltip: group.manual_tooltip,
      }));

      const formattedData = {
        name: originalData.name,
        headline: originalData.headline,
        disclaimer: originalData.disclaimer,
        items: data,
        layout: originalData.layout,
        cta: originalData.cta,
        accessible_roles: originalData.accessible_roles,
      };
      return formattedData;
    },

    updateFiles(document, selectedVersion) {
      const selectedVersionFiles =
        document.find((version) => version.version === selectedVersion) &&
        document.find((version) => version.version === selectedVersion).files;

      // Use $set to ensure reactivity
      this.$set(document, "selectedVersionFiles", selectedVersionFiles);

      // Set the first file as the default selected file
      this.$set(document, "selectedFile", selectedVersionFiles[0].file);
    },
    getFilteredFiles(document, selectedVersion) {
      // Filter files based on the selected version
      return document.find((item) => item.version === selectedVersion);
    },

    showFilter() {
      if ($(window).scrollTop() < 760) {
        $(".filterSelect").css("display", "none");
      } else if ($(window).scrollTop() > 760) {
        $(".filterSelect").css("display", "block");
      }

      if (
        $(window).scrollTop() + $(window).height() >=
        $(document).height() - 200
      ) {
        $(".filterSelect").css("display", "none");
      }
    },
    dataLayer(data, selectedItem) {
      const fileClicked = {
        event: "file_download",
        pdf_name: data.post_title,
        clickURL: selectedItem.file,
        pagePath: window.location.origin + window.location.pathname,
      };

      window.dataLayer.push(fileClicked);
    },
    getType(name) {
      if (name.length && name[0].file) {
        name = name[0].file;
      } else {
        name = null;
      }
      if (name) {
        return name.split(".").pop();
      } else {
        return "--";
      }
    },
    sortItems(event) {
      const eventValue = event.target.value;
      var els = document.getElementsByClassName("sortinput");
      for (var i = 0; i < els.length; i++) {
        //var txt = $(".filterSelect option[value='" + eventValue + "']").trigger("change");
        $(".sortinput").val(eventValue);
      }
      $(".sortbtn").trigger("click");
    },
    sortEdited() {
      var selectedOption = $(".sortinput").val();
      if (selectedOption == 1) {
        this.sortData = this.historicalData.items.sort((a, b) => {
          var getDate = (item) => {
            if (item.historical) {
              var selectedFile = item.files[0].files
                .filter(
                  (file) => file.version === item.files[0].selectedVersion
                )
                .find((file) => file.file === item.files[0].selectedFile);
              return selectedFile ? new Date(selectedFile.date) : new Date(0);
            } else {
              return new Date(item.files[0].date);
            }
          };

          var dateA = getDate(a);
          var dateB = getDate(b);

          return dateB - dateA;
        });
      }
      if (selectedOption == 2) {
        this.sortData = this.historicalData.items.sort((a, b) => {
          var getDate = (item) => {
            if (item.historical) {
              var selectedFile = item.files[0].files
                .filter(
                  (file) => file.version === item.files[0].selectedVersion
                )
                .find((file) => file.file === item.files[0].selectedFile);
              return selectedFile ? new Date(selectedFile.date) : new Date(0);
            } else {
              return new Date(item.files[0].date);
            }
          };

          var dateA = getDate(a);
          var dateB = getDate(b);

          return dateA - dateB;
        });
      }
      if (selectedOption == 3) {
        this.sortData = this.historicalData.items.sort((a, b) => {
          return a.post_title.localeCompare(b.post_title);
        });
      }
      if (selectedOption == 4) {
        this.sortData = this.historicalData.items.sort((a, b) => {
          return b.post_title.localeCompare(a.post_title);
        });
      }
    },

    getSize(item) {
      let fileSize = "--";
      if (item && item.size && item.size != null) {
        fileSize = item.size;
      }
      if (fileSize !== "--") {
        return `${(fileSize / (1024 * 1024)).toFixed(2)} MB`;
      } else {
        return fileSize;
      }
    },

    getDocumentId(url, locked) {
      try {
        if (
          (locked === "false" || locked === "APPROVED" || locked === "true") &&
          url != undefined
        ) {
          let allItems = url.split("/");
          let id = allItems[allItems.length - 1]
            .replace(".pdf", "")
            .split("_")
            .filter((item) => (item.length > 3 ? Number(item) : null));
          return id[0] || "--";
        }
      } catch (error) {
        console.log(error);
        return "--";
      }
    },

    getDocumentDate(items, selectedItem) {
      let documentDate = "--";
      items.find((item) => {
        if (item.version) {
          const selectedFile = item.files.find(
            (file) => file.file === selectedItem
          );
          if (selectedFile) {
            documentDate = this.format_date(selectedFile.date);
            return;
          } else {
            return documentDate;
          }
        } else {
          if (item.file === selectedItem) {
            documentDate = this.format_date(item.date);
          }
        }
      });
      return documentDate;
    },

    format_date(item) {
      if (item != undefined) {
        return moment(String(item)).format("MMM D, YYYY");
      }
    },
    getImagePath(locked) {
      // console.log("getImagePath localed", locked);
      if (locked != "NO_SESSION") {
        if (locked === "REJECTED" || locked === "DENIED") {
          return require("@/assets/images/restricted_icon.png");
        } else if (locked === "PENDING") {
          return require("@/assets/images/pending_approval.png");
        } else if (locked === "APPROVED" || locked === "true") {
          return require("@/assets/images/unlocked_available_icon.png");
        }
      } else {
        return require("@/assets/images/locked.png");
      }
    },
    getDocumentCta(text, locked) {
      // console.log("getDocumentCta locked", text, locked);
      let ctaText = `${this.$getTranslation(
        "Login to",
        this.$route.params.region
      )} ${text}`;
      // let siteUrl = this.$route.params.region;
      // console.log("siteUrl",siteUrl);

      if (locked != "NO_SESSION") {
        if (locked === "REJECTED" || locked === "DENIED") {
          ctaText = this.$getTranslation(
            "Access denied",
            this.$route.params.region
          );
        } else if (locked === "PENDING") {
          ctaText = this.$getTranslation(
            "Awaiting approval",
            this.$route.params.region
          );
        } else if (locked === "APPROVED" || locked === "true") {
          ctaText = this.$getTranslation(text, this.$route.params.region);
        }
      } else {
        ctaText = `${this.$getTranslation(
          "Login to",
          this.$route.params.region
        )} ${text}`;
      }
      return ctaText;
    },

    getDocumentHref(url, locked) {
      // let role = $cookies.get("role");
      // console.log("HREF", locked);
      if (locked === "false" || locked === "APPROVED" || locked === "true") {
        return url;
      } else {
        // let regionCode = $cookies.get("RegionCode");
        if (locked === "NO_SESSION") {
          // console.log("HREF", "No session");
          return `${process.env.VUE_APP_ROCUI_ENDPOINT}/${
            this.$route.params.region
          }/signin?product-support&redirect_to=${this.$route.path}`;
        }
        this.invalidAccess = true;
        return "javascript:void(0)";
      }
    },

    // saveMyDownload(url) {
    //     // console.log("362",url);
    //     if (url.includes("/secure")) {
    //       // console.log("364",url);
    //       // Check access => if no access then do not proceed
    //       if (this.getDocumentHref(url, "APPROVED") === "javascript:void(0)") {
    //         return;
    //       }
    //       // Call API
    //       let oktaEndpoint = $cookies.get("rocServ");
    //       let oktaEmail = $cookies.get("rocEmail");
    //       let oktaSid = $cookies.get("rocSid");
    //       let oktaRegion = $cookies.get("RegionCode");
    //       axios({
    //         url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
    //         method: "post",
    //         headers: {
    //           "Content-Type": "application/json",
    //           x_api_key: "121",
    //           session: oktaSid,
    //         },
    //         data: {
    //           query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
    //           createDownloadMaterials(input: $input) {
    //             id
    //           }
    //         }`,
    //           variables: {
    //             input: [
    //               {
    //                 email: oktaEmail,
    //                 materialPath: url,
    //                 materialType: url.slice(-3),
    //                 userId: this.$store.state.userId,
    //                 country: this.$store.state.country,
    //               },
    //             ],
    //           },
    //         },
    //       })
    //         .then(() => {
    //           window.open(url, "_blank").focus();
    //         })
    //         .catch(() => {
    //           // this.removeAllCookies();
    //           window.location.reload();
    //         });
    //     } else {
    //       // console.log("405",url);
    //       window.open(url, "_blank").focus();
    //     }
    //   },

    saveMyDownload(url) {
      // item.errorMessage = null;
      // Check if URL contains "/secure"
      if (url.includes("/secure")) {
        const isSecureDocument = url.includes("secure");
        const isSecureSoftWare = url.includes(".zip");
        const regionCode = $cookies.get("RegionCode");
        const restrictedRegions = ["ja-jp", "de-de", "es-xl", "pt-br", "en-us"]; // Japan, Germany, LATAM, Brazil
        const isRegionRestricted = restrictedRegions.includes(regionCode || "");
        const exclude_ja_jp = restrictedRegions.some((reg) =>
          url.includes(reg)
        );

        // Additional condition for ResScan and zip files
        if (
          url.toLowerCase().includes("/resscan/") &&
          isSecureDocument &&
          isSecureSoftWare
        ) {
          const rocEmail = $cookies.get("rocEmail");
          const internalUser = rocEmail.includes("@resmed");
          const approvedOnCookie = $cookies.get("approvedOn") || "";
          const approvedEntries = decodeURIComponent(approvedOnCookie).split(
            ";"
          );

          const getDateForRole = (role) => {
            const roleEntry = approvedEntries.find(
              (entry) =>
                role && entry.toUpperCase().startsWith(role.toUpperCase())
            );
            if (!roleEntry) {
              console.error(`Role ${role} not found in approvedOn cookie.`);
              return null;
            }
            const datePart = roleEntry.split("_")[1];
            return datePart ? new Date(datePart) : null;
          };

          const roleCookie = $cookies.get("role") || "";
          const getRole = roleCookie
            .split(",")
            .map((item) => item.split("_")[0])
            .filter((role) => role && role.toLowerCase() === "clinical")
            .join();

          const approvedOn = getDateForRole(getRole);
          const march2024 = new Date("2024-03-01");
          if (isSecureDocument && internalUser) {
            axios({
              url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
              method: "post",
              headers: {
                "Content-Type": "application/json",
                x_api_key: "121",
                session: $cookies.get("rocSid"),
              },
              data: {
                query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
              createDownloadMaterials(input: $input) {
                id
              }
            }`,
                variables: {
                  input: [
                    {
                      email: rocEmail,
                      materialPath: url,
                      materialType: url.slice(-3),
                      userId: this.$store.state.userId,
                      country: this.$store.state.country,
                    },
                  ],
                },
              },
            })
              .then(() => {
                window.open(url, "_blank").focus();
              })
              .catch(() => {
                window.location.reload();
              });
          } else if (
            isSecureDocument &&
            !internalUser &&
            approvedOn &&
            (approvedOn < march2024 || (exclude_ja_jp || isRegionRestricted))
          ) {
            axios({
              url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
              method: "post",
              headers: {
                "Content-Type": "application/json",
                x_api_key: "121",
                session: $cookies.get("rocSid"),
              },
              data: {
                query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
              createDownloadMaterials(input: $input) {
                id
              }
            }`,
                variables: {
                  input: [
                    {
                      email: rocEmail,
                      materialPath: url,
                      materialType: url.slice(-3),
                      userId: this.$store.state.userId,
                      country: this.$store.state.country,
                    },
                  ],
                },
              },
            })
              .then(() => {
                window.open(url, "_blank").focus();
              })
              .catch(() => {
                window.location.reload();
              });
          } else {
            this.errorMessage = {
              url,
              error: this.$getTranslation(
                "Invaild User for Downloading",
                this.$route.params.region
              ),
            };
            return;
          }
        } else {
          // Existing condition to check access
          if (this.getDocumentHref(url, "APPROVED") === "javascript:void(0)") {
            return;
          }
          // Call API
          axios({
            url: `${process.env.VUE_APP_ROC_ENPOINT}/graphql`,
            method: "post",
            headers: {
              "Content-Type": "application/json",
              x_api_key: "121",
              session: $cookies.get("rocSid"),
            },
            data: {
              query: `mutation CreateDownloadMaterials($input: [DownloadMaterialInput!]!) {
                createDownloadMaterials(input: $input) {
                  id
                }
              }`,
              variables: {
                input: [
                  {
                    email: $cookies.get("rocEmail"),
                    materialPath: url,
                    materialType: url.slice(-3),
                    userId: this.$store.state.userId,
                    country: this.$store.state.country,
                  },
                ],
              },
            },
          })
            .then(() => {
              window.open(url, "_blank").focus();
            })
            .catch(() => {
              window.location.reload();
            });
        }
      } else {
        // Handle non-secure downloads
        window.open(url, "_blank").focus();
      }
    },

    removeAllCookies() {
      $cookies.remove(
        "rocServ",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "rocEmail",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "rocSid",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "RegionCode",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "b2bFirstName",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "role",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "redirectLoggedPath",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
    },
    getDocumentTarget(url, locked) {
      let pdfUrl = this.getDocumentHref(url, locked);

      if (pdfUrl === "javascript:void(0)") {
        return "";
      } else {
        return "_blank";
      }
    },
  },

  async mounted() {
    inView.threshold(0.2);

    inView(".component-d741a204").on("exit", (el) => {
      this.active = "";
    });

    this.historicalData = await this.convertToFormattedData(await this.acf);

    // set default value for document language
    try {
      const regionLang = await this.getLanguageByRegion();
      await this.historicalData.items.map(async (item) => {
        if (item.files && item.files.length > 0 && !item.files[0].version) {
          const currentLang = await item.files.find(
            (file) => file.language.toLowerCase() === regionLang.toLowerCase()
          );

          if (currentLang !== undefined) {
            this.$set(item.files, "selectedFile", currentLang.file);
          } else {
            this.$set(item.files, "selectedFile", item.files[0].file);
          }
        }
      });
    } catch (error) {
      console.log("error", error);
    }

    // Set default values for selectedVersion and selectedFile
    (await this.historicalData) &&
      (await this.historicalData.items.forEach(async (document) => {
        const regionLang = await this.getLanguageByRegion();

        const currentLang = await document.files[0].files.find(async (item) => {
          return (
            (await item.language.toLowerCase()) ===
            (await regionLang.toLowerCase())
          );
        });

        if (await document.files[0].version) {
          this.$set(
            document.files,
            "selectedVersion",
            document.files[0].version
          );
          // Initialize selectedVersionFiles based on the default selected version
          this.$set(
            document.files,
            "selectedVersionFiles",
            document.files[0].files
          );
        }
        // Set the first file as the default selected file
        if (currentLang != undefined) {
          this.$set(document.files, "selectedFile", currentLang.file);
        } else {
          this.$set(
            document.files,
            "selectedFile",
            document.files.selectedVersionFiles[0].file
          );
          if (document.files[0].version) {
            this.$set(
              document.files,
              "selectedVersion",
              document.files[0].version
            );
            // Initialize selectedVersionFiles based on the default selected version
            this.$set(
              document.files,
              "selectedVersionFiles",
              document.files.selectedVersionFiles[0].file
            );
          }
        }
      }));

    this.sortData = this.historicalData.items.sort((a, b) => {
      var getDate = (item) => {
        if (item.historical) {
          var selectedFile = item.files[0].files
            .filter((file) => file.version === item.files[0].selectedVersion)
            .find((file) => file.file === item.files[0].selectedFile);
          return selectedFile ? new Date(selectedFile.date) : new Date(0);
        } else {
          return new Date(item.files[0].date);
        }
      };

      var dateA = getDate(a);
      var dateB = getDate(b);

      return dateB - dateA;
    });

    window.addEventListener("scroll", () => {
      this.showFilter();
    });
  },
  created() {
    bus.$on("component-d741a204:active", (val) => {
      this.active = val;
    });
    let regionCode = $cookies.get("RegionCode");

    let siteUrl = this.$route.params.region;
    const countryCode = siteUrl.split("/").pop();
    // console.log("481", regionCode,countryCode, this.isResmedUser);
    if (
      !this.isResmedUser &&
      regionCode !== null &&
      regionCode !== countryCode
    ) {
      this.$swal({
        title: this.$getTranslation("Access denied", this.$route.params.region),
        imageUrl: require("../../assets/images/block-black.svg"),
        imageWidth: "4rem",
        imageHeight: "4rem",
        text: this.$getTranslation(
          "This content is only available in selected countries. Please contact customer service if you need further assistance.",
          this.$route.params.region
        ),
        confirmButtonColor: "#0D0A15",
        customClass: "custom-swal-content",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/base/utilities";
.tooltipQualityAssistant.tooltip {
  z-index: 102;
  background: #363636;
  color: #d1d1d1;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  max-width: 250px;
}

.boxShadow {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  // align-items: start;
  margin: auto;
  border-radius: 4px;
  width: 100%;
  border-top: 4px solid #0d0a15;
  // min-height: 162px;
  z-index: 2;
  // max-width: 270px;
  @media only screen and (min-width: 1280px) {
    max-width: 270px;
  }
}

.boxShadow > .boxShadowContainer,
.boxShadow .boxShadowContainer {
  flex-direction: column;
  min-height: 128px;
}

.document_title {
  min-height: 42px;
  display: grid;
  justify-items: baseline;
  align-items: center;
  width: 100%;
  text-align: left;

  @media screen and (min-width: 768px) {
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.document_data {
  font-size: 12px;
  font-weight: 400;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 500;
  color: rgb(169, 169, 169);
}

.internal_only_document {
  height: 18px;
  text-align: left;
}
.internal_only_document > span {
  color: #c00340;
  font-weight: 700;
  font-size: 12px;
}

.document_title > span,
.document_title > strong {
  line-height: 1.6;
}

.select-overlay-container > select {
  border-radius: 50px;
  border: 1px solid #0d0a15;
  padding: 4px 6px;
  min-width: 100px;
  max-width: 100px;
  height: 26px;
  font-size: 12px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 25px;
  background-image: url("#{$assets}/images/icon-down-caret-black.svg");
  background-repeat: no-repeat;
  background-position: 90%;
  background-size: 16px;
}

.disable-pointer-events {
  pointer-events: none;
  color: #999;
}

.select-overlay-container {
  position: relative;
  display: inline-block;
  margin-top: 9px;
}

.select-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.64);
  pointer-events: none;
  border-radius: 50px;
  height: 100%;
  width: fit-content;
  z-index: 1;
}
.component-d741a204 {
  padding: 5rem 0 4rem 0;

  @media (min-width: 992px) {
    padding: 7rem 0 5rem 0;
  }
}

.component {
  &.text-color-white {
    h2,
    h5 {
      color: $cc-resmed-white;

      &:before {
        background-color: $cc-resmed-white;
      }
    }

    .item {
      color: $cc-resmed-white;
    }
  }

  h2 {
    margin: 0 0 2rem 0;
    @media (min-width: 768px) {
      margin: 0;
    }

    &.-has-eyebrow {
      position: relative;
      @extend %eyebrow-center;
    }
  }

  h5 {
    position: relative;
    @extend %eyebrow-center;
  }
  .disclaimer-text {
    width: 75%;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .items {
    margin: 0 auto;
    @media (min-width: 768px) {
      .right-border::after {
        content: "";
        background: #d8d8d8;
        position: absolute;
        bottom: 0%;
        right: 0;
        height: 80%;
        width: 1px;
      }
      .right-border:last-child::after {
        background: none !important;
      }
    }

    @media (min-width: 768px) {
      display: flex;
      justify-content: center;

      padding: 2rem 0 0 0;
    }

    &.n-2 {
      max-width: 620px;

      .item {
        @media (min-width: 992px) {
          width: 50%;
        }
      }
    }

    &.n-3 {
      .item {
        @media (min-width: 768px) {
          width: 33.33333%;
        }

        @media (min-width: 1200px) {
          min-width: 320px;
        }
      }
    }

    &.n-4 {
      .item {
        @media (min-width: 768px) {
          width: 25%;
        }
      }
    }

    strong {
      display: block;
    }

    .item {
      position: relative;
      padding: 1rem 0.675rem 2.5rem 0.675rem;

      @media (min-width: 992px) {
        padding: 1rem 2rem 2.5rem 2rem;
        min-width: 240px;
      }

      > a {
        cursor: pointer;
        position: absolute;
        bottom: 0.75rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .document-meta {
      span {
        color: #3f4f5f;
      }
    }
    .document {
      position: relative;
      z-index: 1;
    }
  }
}

.tooltip {
  animation: fade-in 0.5s ease;

  z-index: 99;
  position: absolute;
  min-width: 275px;
  min-height: 100px;

  // top: 38px;
  left: 50%;
  transform: translateX(-50%);

  display: flex;
  flex-direction: column;

  &:after {
    $size: 0.75rem;
    @include caret($size);
    border-bottom: $size solid $cc-resmed-white;

    left: 50%;
    transform: translateX(-50%);
    top: -1.5rem;
  }

  > .content {
    background-color: $cc-resmed-white;
    box-shadow: 0 0rem 12px 6px rgba(0, 0, 0, 0.125);

    flex-grow: 1;
    // padding: 1.5rem 2rem 1rem 2rem;
    padding: 1.5rem;
    border-radius: 6px;

    text-align: left;
    max-height: 364px;
    overflow-y: auto;

    ul {
      list-style: none;

      li:not(:last-child) {
        // margin-bottom: 1rem;
        margin-bottom: 12px;
        // padding-bottom: 1rem;
        padding-bottom: 12px;
        border-bottom: 1px solid $cc-resmed-bg-grey-1;
      }

      a {
        display: block;
      }

      span {
        @extend %body-small;
        color: $cc-resmed-grey-85;
      }
    }
  }
}

a.btn.cta-plain.text-red.icon a {
  color: #0c0c0c;
}

a.btn.cta-plain.text-red.icon div {
  margin-right: 5px;
}

.pdf-card-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.multicontainer {
  display: grid;
  grid-template-columns: 45% 55%;
  gap: 10px;
}

.filterSelect {
  position: fixed;
  top: 78px;
  z-index: 101;
  min-width: 172px;
  margin-bottom: 30px;
  padding: 6px 12px;
  display: none;
  border-radius: 50px;
  border: 2px solid #0d0a15;
  color: #0d0a15;
  font-weight: 500;
  appearance: none;
  background: #ffffff url(#{$assets}/images/sort-select-icon.svg) no-repeat;
  background-position: 92%;
  background-size: 25px;

  @media screen and (max-width: 768px) {
    top: initial;
    bottom: 16px;
  }
}

.filterSelect > option {
  background-color: #d8d8d8 !important;
}

.showFilterSelect {
  display: block;
}

.sortinput,
.sortbtn {
  display: none;
}

.select-container {
  // display:;
}

.sort-select {
  position: absolute;
  top: 0;
  right: 0;
}

@media (max-width: 768px) {
  .sort-select {
    position: relative;
  }
}
.errorMessage {
  margin: 0px;
  font-size: 10px;
  color: #c00340;
  font-weight: 300;
}
</style>
